import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarOpen: true,
    isCollapsed: false,
    searchOpen: false,
    activeTab: 'general', // for Settings page
  },
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    toggleIsCollapsed: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
    setIsCollapsed: (state, action) => {
      state.isCollapsed = action.payload;
    },
    setSearchOpen: (state, action) => {
      state.searchOpen = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});

export const { toggleSidebar, setSidebarOpen, toggleIsCollapsed, setIsCollapsed, setSearchOpen, setActiveTab } = uiSlice.actions;
export default uiSlice.reducer;
